export const PRESET_LARGE = 'large';
export const PRESET_MEDIUM = 'medium';
export const PRESET_SMALL = 'small';
export const PRESET_REVIEW = 'review';
export const PRESET_CUSTOM = 'custom';

export const TAG_PICKER_PRESETS = [
    PRESET_LARGE,
    PRESET_MEDIUM,
    PRESET_SMALL,
    PRESET_REVIEW,
    PRESET_CUSTOM,
];

export const TAG_PICKER_PRESET_DEFAULT_FIELDS = {
    [PRESET_LARGE]: {
        154: [ // Movie
            842, // Release Date
            1329, // Rating
            1333, // Genres
            1330, // Runtime
            1327, // Cast
            841, // Director
            1328, // Writers
            11457, // Producers
            5998, // Prequel(s)
            5997, // Sequel(s)
            6002, // Franchise(s)
        ],
        216: [ // TV Show
            1342, // Release Date
            13107, // Finale Year
            2255, // Rating
            1345, // Genres
            5990, // Network
            5994, // Showrunner
            1341, // Cast
            5993, // Directors
            7892, // Creator(s)
            2259, // Writers
            5992, // Franchise(s)
        ],
        222: [ // Video Game
            2007, // Released
            11465, // System
            2010, // Genre(s)
            2014, // ESRB
            2008, // Developer(s)
            2009, // Publisher(s)
            11468, // OpenCritic Page
            11470, // Top Critic Rating
            11471, // Critics Recommend %
            2013. // Engine
        ],
        1191: [ // Video Game DLC
            10947, // Released
            11641, // System
            10949, // Genre
            10952, // ESRB
            10944, // Base Game
            10947, // Developer(s)
            10948, // Publisher(s)
            10951, // Engine
            10950, // Multiplayer
        ],
        763: [ // TV Show Season
            8049, // Release Date
            8053, // Rating
            8052, // Genres
            8078, // Network
            12238, // Series
            11738, // Episodes
            8082, // Showrunner
            8081, // Directors
            8076, // Writers
            8080, // Franchise(s)
        ],
        972: [ // Vehicle Sub-Model Year
            11176, // Base Trim Engine
            11157, // Base Trim Drivetrain
            11158, // Base Trim Transmission
        ],
    },
    [PRESET_MEDIUM]: {
        154: [ // Movie
            842, // Release Date
            1329, // Rating
            1333, // Genres
            1330, // Runtime 
        ],
        216: [ // TV Show
            1342, // Release Date
            13107, // Finale Year
            2255, // Rating
            1345, // Genres
            5990, // Network
            5994, // Showrunner 
        ],
        763: [ // TV Show Season
            8049, // Release Date
            8053, // Rating
            8052, // Genres
            8078, // Network
            12238, // Series
            11738, // Episodes 
        ],
        222: [ // Video Game
            2007, // Released
            11465, // System
            2010, // Genre(s)
            2014, // ESRB
        ],
        1191: [ // Video Game DLC
            10947, // Released
            11641, // System
            10949, // Genre
            10952, // ESRB 
        ],
        972: [ // Vehicle Sub-Model Year
            11176, // Base Trim Engine
            11157, // Base Trim Drivetrain
            11158, // Base Trim Transmission
        ],
    },
    [PRESET_SMALL]: {
        154: [ // Movie
            842, // Release Date 
        ],
        216: [ // TV Show
            1342, // Release Date
            13107, // Finale Year 
        ],
        763: [ // TV Show Season
            8049, // Release Date 
        ],
        222: [ // Video Game
            2007, // Released
        ],
        1191: [ // Video Game DLC
            10947, // Released
        ],
        972: [ // Vehicle Sub-Model Year
            11176, // Base Trim Engine
        ],
    }
};

export const TAG_PICKER_PRESET_DEFAULT_FIELDS_FALLBACK = {
    [PRESET_LARGE]: 6,
    [PRESET_MEDIUM]: 4,
    [PRESET_SMALL]: 2,
    [PRESET_REVIEW]: 10,
}


// WEBPACK FOOTER //
// ./js/utils/consts/tag_picker_presets.ts